export class EnvironmentConfig {
  public WeblinkAuthUrl: string;
  public WebApiIsSingleInstance: boolean;
  public WebApiUrl: string;
  public PersonifyIdpDomain: string;

  public constructor() {
    this.WeblinkAuthUrl = '';
    this.WebApiIsSingleInstance = false;
    this.WebApiUrl = '';
    this.PersonifyIdpDomain = '';
  }
}
